import script from "./other.vue?vue&type=script&setup=true&lang=ts"
export * from "./other.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__